import axios from 'axios'

import { BASE_API_URL } from 'src/constants'

import { HttpService } from './http.service'
import { getAdminAppSecretHeader } from 'src/utils'

class StylesService extends HttpService {
  constructor() {
    super(axios, BASE_API_URL)
  }

  async getAccountStyles({
    productId,
    accountId,
  }: {
    productId: string | null
    accountId: string | null
  }) {
    if (productId) {
      return this.get<string | null>(`accounts/styles/product/${productId}`, {
        headers: { ...getAdminAppSecretHeader() },
      })
    }

    if (accountId) {
      return this.get<string | null>(`accounts/styles/account/${accountId}`, {
        headers: { ...getAdminAppSecretHeader() },
      })
    }

    return null
  }
}

export const stylesService = new StylesService()
export default StylesService
